module.exports = __webpack_public_path__ + "img/home_work.3c046a91.svg";